export const OPTIMIZER_DEFINITIONS_PAGE_FILTERS_IDS = {
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  activeState: 'activeState',
};
